import React from "react";
import { HouseholdWith } from "../../models";
import { formatPhone } from "../../formatPhone";

interface Props {
  household: HouseholdWith;
}

const FamilyBox: React.FC<Props> = ({ household }) => {
  return (
    <div>
      <div className="box-for">
        <h3>Family Name</h3> <h3>{household.household_name}</h3>
      </div>
      <div className="box-for">
        <h3>Street Address </h3>
        <h3>{household.street_address}</h3>
      </div>
      <div className="box-for">
        <h3>Zip Code</h3> <h3>{household.zip_code}</h3>
      </div>
      <div className="box-for">
        <h3>Contact Person's Name</h3> <h3>{household.contact_person}</h3>
      </div>
      <div className="box-for">
        <h3>Phone Number</h3> <h3>{formatPhone(household.phone_number)}</h3>
      </div>
      <div className="box-for">
        <h3>Country Of Origin</h3> <h3>{household.country_of_origin}</h3>
      </div>
      <div className="box-for">
        <h3>Preferred Language</h3> <h3>{household.preferred_language}</h3>
      </div>
      <div className="box-for">
        <h3>Preferred Contact Method</h3>{" "}
        <h3>{household.preferred_contact_method}</h3>
      </div>
      <div className="box-for">
        <h3>Days Available</h3> <h3>Todo, add days</h3>
      </div>
    </div>
  );
};

export default FamilyBox;
